import { HttpEventType, HttpResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AppConstant } from 'src/app/helper/class/app-constant';
import { UtiltiyService } from 'src/app/helper/service/utiltiy.service';
import {
  fileCategoryMap,
  fileCompData,
  fileInfo,
  fileType,
} from '../../helper/core.data.interface';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent implements OnInit {
  imageForm: UntypedFormGroup = new UntypedFormGroup({
    pimage: new UntypedFormControl('', []),
  });
  @Output() uploadedFileInfo: EventEmitter<fileInfo> = new EventEmitter();
  fileInfos: fileInfo = {
    filePath: '',
    fileName: '',
    progress: 0,
  };
  fileList: fileInfo[] = [];
  fileStatusMessage: string = '';
  data: fileCompData = {
    label: '',
    filePath: '',
    fileType: 'IMAGE',
    multiple: false,
  };
  fileAccessType: fileCategoryMap<fileType> = {
    IMAGE: {
      pattern: /(jpg|jpeg|png|gif)$/i,
      accessType: '.png, .jpeg,.jpg',
      maxFileSize: AppConstant.MAX_IMAGE_UPLOAD_SIZE,
    },
    FILE: {
      pattern: /(doc|docx|pdf|txt)$/i,
      accessType: '.doc, .docx,.pdf,.txt',
      maxFileSize: AppConstant.MAX_FILE_UPLOAD_SIZE,
    },
    VIDEO: {
      pattern: /(doc|docx|pdf|txt)$/i,
      accessType: '.doc, .docx,.pdf,.mp4',
      maxFileSize: AppConstant.MAX_VIDEO_UPLOAD_SIZE,
    },
    IMAGE_FILE: {
      pattern: /(doc|docx|pdf|txt|jpg|jpeg|png|gif)$/i,
      accessType: '.doc, .docx,.pdf,.txt,.png, .jpeg,.jpg',
      maxFileSize: AppConstant.MAX_FILE_UPLOAD_SIZE,
    },
    APP_BUILD: {
      pattern: /(apk|zip)$/i,
      accessType: '.apk,.zip',
      maxFileSize: 20000000,
    },
  };
  @Input() public set inputFile(data: any) {
    if (!data || (Array.isArray(data) && data.length === 0)) {
      this.fileList = [];
      this.resetInternalState();
      return;
    }

    let items: any[] = [];
    if (Array.isArray(data)) {
      items = data.filter((i) => i);
    } else if (typeof data === 'string' && data.includes(',')) {
      items = data
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s);
    } else if (data) {
      items = [data];
    }

    this.fileList = items
      .map((item) => {
        const isString = typeof item === 'string';
        const filePath = isString
          ? item
          : item.filePath || item.path || item.file_path || '';
        const fileName = isString
          ? item.split('/').pop() || 'File'
          : item.label ||
            item.name ||
            item.file_name ||
            filePath.split('/').pop() ||
            'File';

        let fType: any = isString ? null : item.fileType;
        if (!fType || !this.fileAccessType[fType]) {
          fType = this.getFileTypeFromPath(filePath);
        }

        return {
          filePath,
          fileName,
          progress: 0,
          fileType: fType,
        } as any;
      })
      .filter((f) => f.filePath);

    if (this.fileList.length > 0) {
      this.fileInfos = { ...this.fileList[0] };
      this.data = {
        ...this.data,
        label: this.fileInfos.fileName,
        filePath: this.fileInfos.filePath,
        fileType: (this.fileInfos as any).fileType || 'IMAGE',
      };
    } else {
      this.resetInternalState();
    }
    if(data){
      this.data.fileType = data.fileType || 'IMAGE';
    }
  }
  @Input() set multiple(val: boolean) {
    this.data.multiple = val;
  }
  @Input() disabled: boolean = false;
  constructor(
    private utilityService: UtiltiyService,
    private changeDetect: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {}

  getFileTypeFromPath(path: string): any {
    const ext = (path || '').split('.').pop()?.toLowerCase() || '';
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'IMAGE';
    if (['mp4', 'avi', 'mov', 'mkv'].includes(ext)) return 'VIDEO';
    return 'FILE'; // default: pdf, doc, txt, etc.
  }

  //assign new value for modal
  setInput(data: any) {
    this.inputFile = data;
    if (data && typeof data === 'object') {
      this.data = { ...this.data, ...data };
    }
  }

  handleFileInput(e: any) {
    const fileList: FileList = e.target?.files;
    if (!fileList || !this.documentValidation(fileList[0])) {
      this.resetFileInput();
      return false;
    }
    // turn FileList into File[]
    const files: File[] = Array.from(fileList);
    files.forEach((file) => this.uploadFiles(file));

    return (this.fileStatusMessage = '');
  }

  resetFileInput(index?: number) {
    if (index !== undefined && this.fileList.length > 0) {
      this.fileList.splice(index, 1);
      if (this.fileList.length === 0) {
        this.resetInternalState();
      }
    } else {
      this.fileList = [];
      this.resetInternalState();
    }
  }

  private resetInternalState() {
    this.fileList = [];
    this.fileInfos.filePath = '';
    this.fileInfos.fileName = '';
    this.imageForm.patchValue({ pimage: null });
  }

  documentValidation(files: File) {
    const currentType = this.data.fileType || 'IMAGE';
    const fileText = this.data.fileType
      .replace(/([A-Z]+)/g, ' $1')
      .replace(/([A-Z][a-z])/g, ' $1');
    const fileRule = this.fileAccessType[currentType];
    if (files) {
      // ✅ Dynamic size check
      if (files.size > fileRule.maxFileSize) {
        const maxSizeMB = (fileRule.maxFileSize / (1024 * 1024)).toFixed(1);
        this.fileStatusMessage = `${fileText} size exceeds ${maxSizeMB} MB`;
        return false;
        // }
        // if (files.size > 1000000) {
        //   this.fileStatusMessage = fileText + ' Size Exceed 1 MB';
        //   return false;
      } else if (!this.isValidDocument(files.name.split('.').pop())) {
        this.fileStatusMessage = fileText + ' Type Not Supported';
        return false;
      } else return true;
    }
    return false;
  }

  isValidDocument(image: any) {
    if (image.match(this.fileAccessType[this.data.fileType]?.pattern))
      return true;
    else return false;
  }

  uploadFiles(file: any) {
    this.fileInfos.progress = 1;
    this.utilityService.uploadFiles(file).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.fileInfos.progress = Math.round(
            (100 * event.loaded) / event.total,
          );
        } else if (event instanceof HttpResponse) {
          if (event.body.statusCode == 200) {
            this.fileInfos.progress = 0;
            this.fileStatusMessage = '';
            const newFile: fileInfo = {
              fileName: event.body.result.file_name,
              filePath: event.body.result.file_path,
              progress: 0,
            };

            if (this.data?.multiple) {
              this.fileList.push(newFile);
            } else {
              this.fileInfos = newFile;
              this.fileList = [newFile];
            }

            this.uploadedFileInfo.emit(
              this.data?.multiple ? (this.fileList as any) : this.fileInfos,
            );
            this.changeDetect.detectChanges();
          }
        }
      },
      (err) => {
        this.fileInfos.progress = 0;
        this.resetInternalState();
        this.fileStatusMessage = 'Could not upload the file:' + file.name;
      },
    );
  }

  checkIsImage(path: string): boolean {
    if (!path) return false;
    const ext = path.split('.').pop()?.toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '');
  }

  get isImage(): boolean {
    if (!this.fileInfos?.filePath) return false;
    const ext = this.fileInfos.filePath.split('.').pop()?.toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '');
  }

  getFileIcon(path?: string): string {
    const targetPath = path || this.fileInfos?.filePath;
    if (!targetPath) return 'pi-file';
    const ext = targetPath.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'pdf':
        return 'pi-file-pdf text-danger';
      case 'doc':
      case 'docx':
        return 'pi-file-word text-primary';
      case 'xls':
      case 'xlsx':
        return 'pi-file-excel text-success';
      case 'txt':
        return 'pi-file-edit text-muted';
      default:
        return 'pi-file text-info';
    }
  }
}
